import { getDisplayUsername } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { User } from '@wellesley/openapi'

type CutUserInfoProps = {
  user: User
  maxShortenedInfo?: boolean
}

const getLimits = (isInternal: boolean, maxShortenedInfo = false) => {
  return {
    displayName: maxShortenedInfo ? 14 : 28,
    userName: maxShortenedInfo ? (isInternal ? 14 : 6) : isInternal ? 25 : 10,
  }
}

const truncateString = (input = '', limit: number) => {
  return input.length > limit ? input.slice(0, limit) + '...' : input
}

const splitUsername = (input: string) => {
  const parts = input.split(/(?=@)/)
  if (parts.length === 2) {
    return [parts[0], parts[1]]
  }
  return []
}

const cutUserInfo = ({ user, maxShortenedInfo }: CutUserInfoProps) => {
  const isInternal = user.local

  const limits = getLimits(isInternal, maxShortenedInfo)

  const fullUsername = getDisplayUsername(getUserNameWithDomain(user))

  const displayName =
    user.displayName.length <= limits.displayName
      ? user.displayName
      : truncateString(user.displayName, limits.displayName)

  const splittedUsername = splitUsername(fullUsername)

  const userName =
    fullUsername.length <= limits.userName
      ? fullUsername
      : isInternal
        ? truncateString(fullUsername, limits.userName)
        : `${truncateString(splittedUsername[0], limits.userName)}${truncateString(splittedUsername[1], limits.userName)}`

  return { displayName, userName }
}

export default cutUserInfo
